<div class="row g-0 screen-height">

<div class="col-12 col-md-6 col-lg-5 col-xl-4 col-xxl-3 sidebar p-5 pb-6 overflow-y-scroll">

    <div *ngIf="this.screenHeight < 850 || this.screenWidth < 768" class="mb-5">
      <div class="mb-3 text-white" (click)="collapse.toggle()">
        <img class="drop-ico" src="assets/svg/{{this.userBloodGroup}}.svg">
        <span class="drop-ico-text">{{(user$|async).firstname}} {{(user$|async).lastname}}

        <ng-container *ngIf="isCollapsed">
          <i class="fa fa-chevron-down" aria-hidden="true"></i>
        </ng-container>

        <ng-container *ngIf="!isCollapsed">
          <i class="fa fa-chevron-up" aria-hidden="true"></i>
        </ng-container>

        </span>
      </div>

      <div #collapse="ngbCollapse" [(ngbCollapse)]="isCollapsed">
        <div class="text-white">
          <p class="mb-3">Krevní skupina: {{(user$|async).bloodGroup}}</p>
          <p class="mb-3">Absolvovaných odběrů: {{this.userPast}}</p>
          <p class="mb-3">Email: {{(user$|async).email}}</p>
          <p class="mb-3">Telefon: {{(user$|async).phone}}</p>
          <div *ngIf="_router.url === '/user'">
            <button (click)="logout()" class="btn btn-sm btn-outline-light me-2 my-1"><i class="fa fa-sign-out" aria-hidden="true"></i> Odhlásit se</button>
            <button routerLink="/user/reservations" class="btn btn-sm btn-outline-light me-2 my-1"><i class="fa fa-calendar-check-o" aria-hidden="true"></i> Moje rezervace</button>
            <!-- <button routerLink="/page/documents" class="btn btn-sm btn-outline-light me-2 my-1"><i class="fa fa-cloud-download" aria-hidden="true"></i> Dokumenty</button> -->
          </div>
          <div *ngIf="_router.url === '/user/reservations'">
            <button (click)="logout()" class="btn btn-sm btn-sm btn-outline-light me-2 my-1"><i class="fa fa-sign-out" aria-hidden="true"></i> Odhlásit se</button>
            <button routerLink="/user" class="btn btn-sm btn-outline-light me-2 my-1"><i class="fa fa-calendar-plus-o" aria-hidden="true"></i> Nová rezervace</button>
            <button routerLink="/page/documents" class="btn btn-sm btn-outline-light me-2 my-1"><i class="fa fa-cloud-download" aria-hidden="true"></i> Dokumenty</button>
          </div>
          <div *ngIf="_router.url.split('?')[0] === '/user/confirm'"><button (click)="logout()" class="btn btn-sm btn-sm btn-outline-light me-2"><i class="fa fa-sign-out" aria-hidden="true"></i> Odhlásit se</button></div>

        </div>
      </div>

    </div>

    <div *ngIf="this.screenHeight > 850 && this.screenWidth > 768" class="sidebar-component-1 text-white">
      <div class="mb-3">
        <img class="drop-ico" src="assets/svg/{{this.userBloodGroup}}.svg">
        <span class="drop-ico-text">{{(user$|async).firstname}} {{(user$|async).lastname}}</span>
      </div>
      <p class="mb-3">Krevní skupina: {{(user$|async).bloodGroup}}</p>
      <p class="mb-3">Absolvovaných odběrů: {{this.userPast}}</p>
      <p class="mb-3">Email: {{(user$|async).email}}</p>
      <p class="mb-3">Telefon: {{(user$|async).phone}}</p>
      <div *ngIf="_router.url === '/user'">
        <button (click)="logout()" class="btn btn-sm btn-outline-light me-2 my-1"><i class="fa fa-sign-out" aria-hidden="true"></i> Odhlásit se</button>
        <button routerLink="/user/reservations" class="btn btn-sm btn-outline-light me-2 my-1"><i class="fa fa-calendar-check-o" aria-hidden="true"></i> Moje rezervace</button>
        <button routerLink="/page/documents" class="btn btn-sm btn-outline-light me-2 my-1"><i class="fa fa-cloud-download" aria-hidden="true"></i> Dokumenty</button>
      </div>
      <div *ngIf="_router.url === '/user/reservations'">
        <button (click)="logout()" class="btn btn-sm btn-outline-light me-2 my-1"><i class="fa fa-sign-out" aria-hidden="true"></i> Odhlásit se</button>
        <button routerLink="/user" class="btn btn-sm btn-outline-light me-2 my-1"><i class="fa fa-calendar-plus-o" aria-hidden="true"></i> Nová rezervace</button>
        <button routerLink="/page/documents" class="btn btn-sm btn-outline-light me-2 my-1"><i class="fa fa-cloud-download" aria-hidden="true"></i> Dokumenty</button>
      </div>
      <div *ngIf="_router.url.split('?')[0] === '/user/confirm'"><button (click)="logout()" class="btn btn-sm btn-sm btn-outline-light me-2"><i class="fa fa-sign-out" aria-hidden="true"></i> Odhlásit se</button></div>

    </div>

    <div class="sidebar-component-2 text-white">
      <div *ngIf="_router.url.split('?')[0] === '/user/confirm'"><app-selected></app-selected></div>
      <div *ngIf="_router.url === '/user' || _router.url === '/user/reservations'"><app-calendar (DateSelect)="onSelectDate($event)" (TypeSelect)="onSelectType($event)"></app-calendar></div>
    </div>


</div>

<div class="col-12 col-md-6 col-lg-7 col-xl-8 col-xxl-9">

  <router-outlet></router-outlet>

</div>

</div>

<div class="footer bg-primary text-white z-10">
  Hematologicko-transfuzní oddělení | Městská nemocnice Čáslav | <a class="text-white text-decoration-none" href="/page/privacy-policy" > Zpracování osobních údajů</a> | <a class="text-white text-decoration-none" data-bs-toggle="modal" data-bs-target="#exampleModal"> <i class="fa fa-support"></i> Podpora</a>
</div>

<div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Podpora</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        Svůj dotaz či hlášení prosím směřujte na email support@techcrowd.cz
      </div>
      <div class="modal-footer">
        <a href="mailto:support@techcrowd.cz" class="btn btn-primary">Napsat email</a>
      </div>
    </div>
  </div>
</div>
